import React from 'react';
import { baseURL, currentUserSubject } from '../../../_helpers';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import { Button } from 'reactstrap';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import { Dot } from "react-animated-dots";
import logo from '../../../shared/img/logo/logohome.png'

class LogIn extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      email_address: "",
      password: "",
      showPassword: false,
      setShowPassword: false,
      channel_type: "portal",
      error: "",
      errorMsg: "",
      role: "",
      id: "",
      user: [],
      statusMessage: "",
      isShowSuccess: false,
      submitted: false,
      alert_error_color: "",
      isLoggedIn: false,
      isChecked: false,
      errorShow: false,
      successShow: false,
      statis: []
    };

  }

  handleChangeEmail = event => {
    this.setState({ email_address: event.target.value });
  };
  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };


  showPasswordToggle = () => {
    // eslint-disable-next-line
    if (this.state.showPassword == true) {
      this.setState({
        showPassword: false,
      })
    } else {
      this.setState({
        showPassword: true,
      })
    }
  };

  onSubmit = e => {

    e.preventDefault();
    this.setState({ isLoading: true });
    // eslint-disable-next-line
    if (this.state.email_address == "" || this.state.password == "") {
      this.setState({
        isLoading: false,
        error: "Username and password is required",
        errorShow: true,
        submitted: true,

        alert_error_color: "alert alert-danger"
      });
    } else {

      let formData = {
        "username": this.state.email_address,
        "password": this.state.password,
      }

      console.log("DATA", formData)

      this.setState({ isLoading: true });
      axios.post(baseURL + 'login', formData
      ).then((response) => {
        // console.log("token", response.data.success);
        // eslint-disable-next-line
        if (response.data.success == true) {
          currentUserSubject.next(response.data);
          window.user = response.data;
          this.setState({
            statusMessage: "Login Success! Redirecting....",
            isShowError: true,
            errorShow: false,
            submitted: true,
            isLoggedIn: true
          });
          // console.log('data', response.data.message.role_id)
          localStorage.setItem("name", response.data.message.firstname + " " + response.data.message.lastname)
          localStorage.setItem("msisdnrecord", response.data.message.msisdn)
          localStorage.setItem("user_role", response.data.message.role_id)
          localStorage.setItem("token", response.data.token)
          localStorage.setItem("useridd", response.data.message.id)

          localStorage.removeItem("CUSTOMER_NUMBER")
          // eslint-disable-next-line

          localStorage.setItem("username", response.data.message.username)

          if (response.data.message.role_id == 10) {
            window.setTimeout(function () {
              window.location.href = "/presenters";
              this.setState({ isLoading: false });
            }, 100);
          } else {
            window.setTimeout(function () {
              window.location.href = "/user_search";
              this.setState({ isLoading: false });
            }, 100);

          }
        }
        else {
          console.log("bayoo", response.data)
          this.setState({
            alert_error_color: "alert alert-danger",
            errorShow: true,
            error: response.data.message,
            submitted: true,
            isLoading: false
          }, function () {
            console.log('data', response.data.message)
          });
        }
      }).catch(error => {
        console.log('bayoo', error.response)
        this.setState({
          alert_error_color: "alert alert-danger",
          errorShow: true,
          error: "wrong credentials",
          submitted: true,
          isLoading: false
        });
        this.setState({ password: "", email_address: "" });
      })
    }
  };




  componentDidMount() {
    this.setState({ isChecked: true });
    axios.get('http://www.geoplugin.net/json.gp').then(res => {
      this.setState({ statusMessage: res.data.status_message, isShowError: false, isLoading: false });
      this.setState({
        students: res.data,
        isLoading: false,
      },
        function () {
          console.log("data", res.data);
        });
    });
  }

  render() {
    const { submitted } = this.state;
    const { showPassword } = this.state;

    const { errorShow } = this.state;

    return (
      <div className="account account--photo">

        <div className="account__wrapper">

          <div className="account__card" >
            {/* <img src={logo} alt="" /> */}
            <h1 style={{ color: "white", alignContent: "center", textAlign: "center", fontSize: "100dp" }}><b>FunuaPesa</b></h1>
            <br /><br />
            <Form className="form login-form" onSubmit={this.onSubmit}>
              {submitted ? (
                <>
                  {this.state.isShowError ? (
                    <div
                      color="success"
                      style={{ fontSize: "13px", color: "green" }}>
                      {this.state.statusMessage}
                    </div>

                  ) : null}
                  {errorShow && (

                    <div>
                      <div
                        color="red"
                        style={{ fontSize: "13px", color: "red" }}>
                        {this.state.error}
                      </div>
                      {this.state.errorShow ? (
                        <div
                        >
                          <p
                            style={{ textAlign: "left", marginLeft: "20px" }}
                          >
                            {
                              <div
                                color="primary"
                                style={{ fontSize: "13px", color: "green" }}>
                                {this.state.statusMessage}
                              </div>
                            }{" "}
                            {this.state.isLoggedIn ? (
                              <span>
                                <Dot>.</Dot>
                                <Dot>.</Dot>
                                <Dot>.</Dot>
                              </span>
                            ) : null}
                          </p>

                        </div>
                      ) : null}
                    </div>
                  )}

                </>
              ) : null}
              <div className="form__form-group">
                <br />
                <span className="form__form-group-label">Username</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <AccountOutlineIcon />
                  </div>
                  <Form.Control
                    autoFocus
                    type="text"
                    name="username"
                    style={{ color: "black" }}
                    placeholder="Username"
                    className="input-without-border-radius"
                    value={this.state.email_address}
                    onChange={this.handleChangeEmail}
                  />

                </div>
              </div>
              <div className="form__form-group"><br />
                <span className="form__form-group-label">Password</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <KeyVariantIcon />
                  </div>
                  <Form.Control
                    value={this.state.password}
                    placeholder="Password"
                    name="password"
                    style={{ color: "black" }}
                    type={showPassword ? 'text' : 'password'}
                    className="input-without-border-radius"
                    onChange={this.handleChangePassword}
                  />
                  <button
                    type="button"

                    className={`form__form-group-button${showPassword ? 'active' : ''}`}
                    onClick={this.showPasswordToggle}
                  ><EyeIcon />
                  </button>
                </div>
                <br /><br />
              </div>

              <div className="form__form-group">
                {
                  <Button className="account__btn" type='submit' outline color="login"> {
                    this.state.isLoading ? "Please wait..." : "Sign In"
                  }</Button>

                }
              </div>
            </Form>

          </div>
        </div>
      </div>
    );
  }
}

export default LogIn;
